import { axiosClient } from "services/axios";

export function deleteArticle(articleid: string) {
  return axiosClient.delete("article/", { params: { articleid } });
}
